exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share-item{transition:all .15s}@media screen and (min-width:1280px){.share-item:hover{box-shadow:0 0 8px 0 rgba(0,0,0,.09)}}.alert--copied{border-color:#fff;background-color:hsla(0,0%,90.2%,.4509803922);color:#8c8c8c;width:100%;text-align:center}", ""]);

// exports
